import React, { useEffect } from 'react'

import cn from 'classnames'
import styles from './styles.module.scss'

import { useDispatch, useSelector } from 'react-redux'
import {
  updateFilters,
  updateVacanciesList,
  clearVacancyList,
} from '../../../redux/vacancyManager/vacancyManager.action'
import Input from '../../../UI/Input/Input'
import useInfiniteScroll from '../../../hooks/useInfiniteScroll'
import { getAuthCompanyVacancies } from '../../../api/getApi'
import { vacancyDataHelper } from '../../../helpers/vacancyManager.helper'
import { objToQueryConverter } from '../../../helpers/apiHelper'
import WithPreloader from '../../../HOC/WithPreloader'
import VacancyManagerList from './VacancyManagerList'
import useInput from '../../../hooks/useInput'
import useDebounce from '../../../hooks/useDebounce'
import Button from '../../../UI/Button/Button'

const tabName = {
  archive: 'archive',
  all: 'all',
}

const orderingFields = ['join_date', 'is_active', 'salary', 'duration', 'published_at']

const VacancyManagerListHeader = () => {
  const { value, onChange } = useInput('')

  const { filters, count_active, count_deleted } = useSelector(({ vacancies }) => vacancies)

  const dispatch = useDispatch()

  const debounceValue = useDebounce(value, 500)

  useEffect(() => {
    return () => {
      dispatch(clearVacancyList())
      dispatch(updateFilters({ search: '' }))
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const search = debounceValue.trim()

    dispatch(updateFilters({ search }))

    // eslint-disable-next-line
  }, [debounceValue])

  const { loading, nextPage, handleScroll } = useInfiniteScroll(
    getAuthCompanyVacancies,
    updateVacanciesList,
    vacancyDataHelper,
    objToQueryConverter(filters)
  )

  const handleTabClick = ({ target }) => {
    const { name } = target

    if (name === tabName.archive && filters.deleted) return
    if (name === tabName.all && !filters.deleted) return

    dispatch(updateFilters({ deleted: name === tabName.archive }))
  }

  const handleClearSort = () => {
    setOrderByList([])
    dispatch(updateFilters({ ordering: '' }))
  }

  const [orderByList, setOrderByList] = React.useState([])

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.header_nav}>
          <button
            className={cn(styles.tab, { [styles.tab__active]: !filters.deleted })}
            onClick={handleTabClick}
            name={tabName.all}
          >
            All vacancies {count_active && !filters.deleted ? `(${count_active})` : null}
          </button>

          <button
            className={cn(styles.tab, { [styles.tab__active]: filters.deleted })}
            onClick={handleTabClick}
            name={tabName.archive}
          >
            Archive {count_deleted && filters.deleted ? `(${count_active})` : null}
          </button>
        </div>

        <div className={styles.input}>
          <Input theme="search" value={value} onChange={onChange} />
        </div>
      </div>
      <div className={styles.sort}>
        {orderingFields.map((field) => {
          if (field === 'is_active' && filters.deleted) return
          const asc = field
          const desc = `-${field}`
          const index = orderByList.findIndex((f) => f === asc || f === desc)
          const isActive = index !== -1
          const isDesc = orderByList[index] && orderByList[index].startsWith('-')
          const orderLabel = isActive ? `(${index + 1})` : ''

          const toggleSortField = () => {
            const newOrder = [...orderByList]
            if (index === -1) {
              newOrder.push(asc)
            } else if (newOrder[index] === asc) {
              newOrder[index] = desc
            } else {
              newOrder.splice(index, 1)
            }

            setOrderByList(newOrder)
            dispatch(updateFilters({ ordering: newOrder.join(',') }))
          }

          return (
            <Button
              key={field}
              className={cn(styles.sortButton, { [styles.active]: isActive })}
              onClick={toggleSortField}
            >
              {field.replace('_', ' ')} {isActive ? (isDesc ? '▼' : '▲') : ''} {orderLabel}
            </Button>
          )
        })}
        <Button
          theme="transparent"
          className={cn(styles.sortButton, styles.sortButton_clear, {
            [styles.sortButton_clear_active]: orderByList.length > 0,
          })}
          onClick={handleClearSort}
        >
          clear
        </Button>
      </div>
      <WithPreloader
        size={150}
        component={VacancyManagerList}
        type="magnifier"
        loading={nextPage ? loading : null}
        isActive={nextPage === 1 && loading}
        handleScroll={handleScroll}
      />
    </div>
  )
}

export default VacancyManagerListHeader
